export default {
  'MUSICA': {
    en: 'MÚSICA',
    es: 'MÚSICA',
    pt: 'MÚSICA',
  },
  'PARA': {
    en: 'PARA',
    es: 'PARA',
    pt: 'PARA',
  },
  'RESPIRAR': {
    en: 'RESPIRAR',
    es: 'RESPIRAR',
    pt: 'RESPIRAR',
  },
  'pide': {
    en: 'REQUEST',
    es: 'PIDE TU',
    pt: 'SOLICITE',
  },
  'concierto': {
    en: "YOUR CONCERT",
    es: "CONCIERTO",
    pt: "SEU SHOW"
  },
  'Read more': {
    en: "Read more",
    es: "Lee más",
    pt: "Leia mais"
  },
  'graphicdesign': {
    en: "Graphic design",
    es: "Diseño gráfico",
    pt: "Design gráfico"
  },
  'webdesign': {
    en: "Web design",
    es: "Diseño web",
    pt: "Design web",
  },
  'thisisP1': {
    en: 'THIS IS THE WEEK OF MÚSICA PARA RESPIRAR 24/7, JOIN',
    es: 'ESTA ES LA SEMANA DE MÚSICA PARA RESPIRAR 24/7, UNETE A',
    pt: 'ESTA É A SEMANA DA MÚSICA PARA RESPIRAR 24/7, JUNTE-SE',
    },
  'thisisP2': {
    en: 'US AND ENJOY LIVE MUSIC WHEREVER YOU ARE',
    es: 'NOSOTROS Y DISFRUTA DE MÚSICA EN VIVO DONDE SEA QUE ESTÉS',
    pt: 'NÓS E DESFRUTE DE MÚSICA AO VIVO ONDE VOCÊ ESTIVER ',
}
}
